module.exports = __webpack_public_path__ + "static/media/holly-berry.88b79ad2.svg";